module.exports = __webpack_public_path__ + "img/up_arrow.05a4c908-32913ec4.633c3388.svg";